module.exports = __webpack_public_path__ + "static/media/roman_k.136e1520.jpg";